var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Promotion, Rocket",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11614",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11615",
    d: "M12.94 11.06l-7.07 7.07",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11616",
    d: "M6.633 13l-3.463-.819a.5.5 0 01-.239-.84l2.754-2.754a1 1 0 01.7-.293l3.105-.027",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11617",
    d: "M19.879 8.975l.808-3.888a1.5 1.5 0 00-1.774-1.774l-3.888.808A5.993 5.993 0 0012 5.753L8.814 8.942a8.006 8.006 0 00-2.259 4.5l-.011.073a3.481 3.481 0 00.982 2.961h0a3.476 3.476 0 002.961.981l.073-.011a8 8 0 004.5-2.259L18.247 12a5.993 5.993 0 001.632-3.021z",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11618",
    d: "M13.4 4.714a22.415 22.415 0 015.886 5.886",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 11619",
    d: "M11 17.367l.818 3.463a.5.5 0 00.84.239l2.754-2.754a1 1 0 00.293-.7l.027-3.1",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
export default SvgFast;


//////////////////
// WEBPACK FOOTER
// ./src/icons/fast.svg
// module id = 199
// module chunks = 11